import { render } from "./GenericChartModal.vue?vue&type=template&id=e1ead7f8&ts=true"
import script from "./GenericChartModal.vue?vue&type=script&lang=ts"
export * from "./GenericChartModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__